export const MARKING_VALIDATION_STATUS = Object.freeze({
  VALID: 'VALID',
  REJECTED: 'REJECTED',
  UNAVAILABLE: 'UNAVAILABLE',
  NOT_REQUIRED: 'NOT_REQUIRED',
});
